import { render, staticRenderFns } from "./EntitiesDetails.vue?vue&type=template&id=1f344f6a"
import script from "./EntitiesDetails.vue?vue&type=script&lang=js"
export * from "./EntitiesDetails.vue?vue&type=script&lang=js"
import style0 from "./EntitiesDetails.vue?vue&type=style&index=0&id=1f344f6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports